import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import React from 'react';
import { REFERRAL_PROGRAM_AMOUNT } from '~domain/variables/variables';
import { NavbarButton } from '~frontend-common/components/base-navbar';
import { useTranslator } from '~frontend-common/i18n/translator';
import { PlaceholderPill } from '~ui-kit/components/placeholders';
import { theme } from '~ui-kit/theme';
import { referralMagicLinkService } from '~web-portal/services/referral-magic-link-service';
import { Images } from '~web-portal/theme/images';

export function ReferAFriendButton() {
  const { tl, getCurrentLanguageId } = useTranslator();
  const languageId = getCurrentLanguageId();
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints[0]})`);

  const referralLinkQuery = useQuery({
    queryKey: ['referral-link', languageId],
    queryFn: () => referralMagicLinkService.getLink(languageId),
  });

  if (referralLinkQuery.isLoading) {
    return <PlaceholderPill $width={['56px', '128px']} />;
  }

  if (isNil(referralLinkQuery.data)) {
    return null;
  }

  return (
    <NavbarButton
      data-id="btn-refer-a-friend"
      iconSrc={Images.header.referral}
      href={referralLinkQuery.data}
      tooltip={tl('ui.navbar.tooltip.referral', { fillers: [REFERRAL_PROGRAM_AMOUNT] })}
      label={!isMobile && tl('ui.navbar.referral', { fillers: [REFERRAL_PROGRAM_AMOUNT] })}
    />
  );
}
